import React from 'react'

export default class IconsEnvelopeOutlineTick extends React.Component {
    render() {
        let color = '#C8C5FE'
        if (this.props.color) color = this.props.color
        let className = 'icons-icon'

        return (
            <svg
                className={className}
                style={this.props.style}
                xmlns='http://www.w3.org/2000/svg'
                width='20'
                height='20'
                viewBox='0 0 20 20'
                fill='none'
            >
                <path
                    d='M18.3332 10.8335V5.00016C18.3332 4.55814 18.1576 4.13421 17.845 3.82165C17.5325 3.50909 17.1085 3.3335 16.6665 3.3335H3.33317C2.89114 3.3335 2.46722 3.50909 2.15466 3.82165C1.8421 4.13421 1.6665 4.55814 1.6665 5.00016V15.0002C1.6665 15.9168 2.4165 16.6668 3.33317 16.6668H9.99984'
                    stroke={color}
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M18.3332 5.8335L10.8582 10.5835C10.6009 10.7447 10.3034 10.8302 9.99984 10.8302C9.69624 10.8302 9.39878 10.7447 9.1415 10.5835L1.6665 5.8335'
                    stroke={color}
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M13.3335 15.8332L15.0002 17.4998L18.3335 14.1665'
                    stroke={color}
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </svg>
        )
    }
}
